import { render, staticRenderFns } from "./c-draggable-list-field.vue?vue&type=template&id=0f7952f0&"
import script from "./c-draggable-list-field.vue?vue&type=script&lang=js&"
export * from "./c-draggable-list-field.vue?vue&type=script&lang=js&"
import style0 from "./c-draggable-list-field.vue?vue&type=style&index=0&id=0f7952f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports